import React from 'react'
import image from '../asset/comingsoon.jpg'

export default function BecomeaMember() {
  
  return (
    <center><img src={image} height="200px" width="200px" ></img></center>
  )
}
